export interface Image {
  path: string;
}
